import { environmentBase } from './environment.base';
import { Environment } from './environment.model';
import { AuthUtils } from '@libs/core/auth';

export const environment: Environment = {
  ...environmentBase,

  apiUrl: 'https://maurelli-pt-api-testing.zupit.software',
  auth: {
    ...environmentBase.auth,
    ...AuthUtils.buildStandardAzureADB2CEndpoints('maurellifmatesting', 'B2C_1_SignIn'),
    appId: 'fc446095-2a4f-422b-bb56-2d1a1bde4df1',
    scope: 'offline_access https://maurellifmatesting.onmicrosoft.com/pt-api/access_api',
    logoutUrl: 'https://maurellifmatesting.b2clogin.com/maurellifmatesting.onmicrosoft.com/B2C_1_SignIn/oauth2/v2.0/logout',
    web: {
      redirectUrl: 'https://maurelli-pt-testing.zupit.software',
      windowOptions: 'height=600,left=0,top=0',
    },
    android: {
      redirectUrl: 'msauth://com.maurelligroup.mpt/U2%2BccqARq3%2F1Vrc6OUufYHRIMIo%3D',
    },
    ios: {
      pkceEnabled: true, // workaround for bug https://github.com/moberwasserlechner/capacitor-oauth2/issues/111
      redirectUrl: 'msauth.com.maurelligroup.mpt://auth',
    },
  },
  appEnvironment: 'testing',
  sentry: {
    enable: true,
    dsn: 'https://6bb7a5f9bfe688b122f94c5f56ee6389@sentry.monitoring.zupit.software/3',
  },
};
